const initState = {
    perfectSlabs: [],
    newestColors: [],
    outletProducts: [],
    bannerProducts: [],
    loadingPerfectSlabs: false,
    loadingNewestColors: false,
    loadingOutletProduct: false,
    loadingBannerProduct: false,
}

const naturalStone = (state = initState, action) => {
    switch (action.type) {
        case 'FETCH_PN_BANNER_PRODUCTS_REQUEST':
            return {...state, loadingBannerProduct: true}
        case 'FETCH_PN_BANNER_PRODUCTS_SUCCESS':
            return {...state, loadingBannerProduct: false, bannerProducts: action.payload}
        case 'FETCH_PN_BANNER_PRODUCTS_FAILURE':
            return {...state, loadingBannerProduct: false}
        case 'FETCH_PN_PERFECT_SLABS_REQUEST':
            return {...state, loadingPerfectSlabs: true}
        case 'FETCH_PN_PERFECT_SLABS_SUCCESS':
            return {...state, loadingPerfectSlabs: false, perfectSlabs: action.payload}
        case 'FETCH_PN_PERFECT_SLABS_FAILURE':
            return {...state, loadingPerfectSlabs: false}
        case 'FETCH_PN_NEWEST_REQUEST':
            return {...state, loadingNewestColors: true}
        case 'FETCH_PN_NEWEST_SUCCESS':
            return {...state, loadingNewestColors: false, newestColors: action.payload}
        case 'FETCH_PN_NEWEST_FAILURE':
            return {...state, loadingNewestColors: false}
        case 'FETCH_PN_OUTLET_REQUEST':
            return {...state, loadingOutletProduct: true}
        case 'FETCH_PN_OUTLET_SUCCESS':
            return {...state, loadingOutletProduct: false, outletProducts: action.payload}
        case 'FETCH_PN_OUTLET_FAILURE':
            return {...state, loadingOutletProduct: false}
        default:
            return state;
    }
}

export const getPerfectSlab = state => state.naturalStone.perfectSlabs;
export const getNewestColors = state => state.naturalStone.newestColors;
export const getOutletProducts = state => state.naturalStone.outletProducts;
export const getBannerProducts = state => state.naturalStone.bannerProducts;
export const getIsLoadingPerfectSlabs = state => state.naturalStone.loadingPerfectSlabs;
export const getIsLoadingNewestColors = state => state.naturalStone.loadingNewestColors;
export const getIsLoadingOutletProduct = state => state.naturalStone.loadingOutletProduct;
export const getIsLoadingBannerProduct = state => state.naturalStone.loadingBannerProduct;

export default naturalStone;